(function(){
  function ready(fn){ 
    if (document.readyState !== 'loading') fn(); 
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function(){
    var sections = document.querySelectorAll('[id^="SectionHeading-"]');
    sections.forEach(function(el){
      var data = el.getAttribute('data-headlines') || '[]';
      var list;
      try { list = JSON.parse(data); } catch(e){ list = []; }
      // remove empties/whitespace-only
      list = list.filter(function(x){ return (x||'').trim().length > 0; });
      if (list.length < 2) return; // nothing to rotate

      var delayAttr = el.getAttribute('data-rotate-ms');
      var delay = parseInt(delayAttr || '4000', 10) || 4000;
      var i = 0;

      setInterval(function(){
        el.classList.add('is-fading-out');
        setTimeout(function(){
          i = (i + 1) % list.length;
          el.textContent = list[i];
          el.classList.remove('is-fading-out');
        }, 300);
      }, delay);
    });
  });
})();
